import React, { useEffect, useState } from "react";
import styles from './index.module.css';
import BannerImg from '../../assets/images/brand/hero_img.png';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectUserDetails } from "../../redux/features/auth/authSlice";
import { getUser } from "../../redux/features/auth/authService";

const Banner = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { details } = useSelector(selectUserDetails);

    useEffect(() => {
        dispatch(getUser());
    }, [dispatch]);

    const toggleLogin = () => navigate('/auth/login');
    const toggleSignUp = () => navigate('/courses/generative-ai-for-beginners');

    return (
        <>
            <div className={styles.bannerContainer}>
                <div className={`main-container`}>
                    <div className={`container-content`}>
                        <div className={styles.bannerRow}>
                            <div className={styles.bannerLeft}>
                                <h1>GROW WITH EVERY LESSON</h1>
                                <p>Bridge the gap between theory and practice. Turn concepts into capabilities with courses built to ensure every minute of learning translates into real-world results.</p>
                                <button type="button" className={styles.regBtn} onClick={toggleSignUp}>Get Started</button>
                                {/* {!details.id && (
                                    <>
                                        <button type="button" className={styles.loginBtn} onClick={toggleLogin}>Login</button>
                                        <button type="button" className={styles.regBtn} onClick={toggleSignUp}>Get Started</button>
                                    </>
                                )} */}
                            </div>
                            <div className={styles.bannerRight}>
                                <img src="https://cdn.studyhub.lk/hero_img.webp" alt="Hero image" className={styles.heroImg} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Banner;